export default __webpack_public_path__ + "static/media/test1.33b09bfa.png";